"use client";
import React from "react";
import Combobox from "@/components/primitives/combobox";
import DatePicker from "@/components/primitives/date-picker";
import DateTabber from "@/components/primitives/date-tabber";
import { convertDateToStringWithoutTime, toISOStartOfDay } from "@/utils";
import { useRouter } from "next-nprogress-bar";
import { useQueryUpdater } from "@/utils/hooks/navigation";

export interface PicksSearchParams {
  week: string;
  date: string;
}

export default function PickActivityFilter({
  searchParams,
}: {
  searchParams: PicksSearchParams;
}) {
  const date = searchParams.date !== undefined ? toISOStartOfDay(searchParams.date) : toISOStartOfDay(convertDateToStringWithoutTime(new Date()));
  const router = useRouter();
  const { createQueryParamString } = useQueryUpdater();
  const defaultSearchParams: PicksSearchParams = {
    week: "week-11",
    date: "today",
  }

  function changeDate(date: Date) {
    router.replace(createQueryParamString("date", convertDateToStringWithoutTime(date)), {scroll: false});
  }
    return (
      <>
        {/* <Combobox
          triggerPlaceholder="Select a Week"
          height={16}
          defaultValue={defaultSearchParams.week}
          value={searchParams.week}
          onSelectItem={(v) =>
              router.push(
                `?${new URLSearchParams({
                  week: v,
                  date: searchParams.date || defaultSearchParams.date,
                })}`,
                { scroll: false }
              )
            }
          options={weekFilterOptions}
        /> */}
        <DateTabber value={new Date(date)} onValueChange={(v: Date) => changeDate(v)}/>
        <DatePicker
          mode="single"
          align="end"
          value={new Date(date)}
          onValueChange={(v: Date) => changeDate(v)}
        />
      </>
    );
}
